<script setup>
import { pickFields } from '../../common/pick-fields'

const emit = defineEmits(['update:modelValue', 'selected', 'setDetails'])
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Object,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
})

function getOptionId(valueId){
    return `${props.name}-${valueId}`
}

function onOptionClick(option){
    if(option.id !== props.modelValue.id){
        emit('update:modelValue', pickFields(option, Object.keys(props.modelValue)));
    }

    emit('selected');

    if(option.description){
        emit('setDetails', {
            title: option.title,
            description: option.description,
            image: option.image
        });
    }
}

</script>

<template>
    <div class="ConfiguratorGrid tw-grid tw-grid-cols-2 sm:tw-grid-cols-2 tw-gap-y-2 md:tw-gap-3 lg:tw-gap-x-0 lg:tw-gap-2 xl:tw-gap-3 xxl:tw-gap-4 tw-mb-6">
        <div
            class="ConfiguratorGridItem ConfiguratorOption tw-group tw-w-full"
            v-for="option in props.options"
            :key="option.id"
        >

        <input
            type="radio"
            :value="getOptionId(option.id)"
            :id="getOptionId(option.id)"
            :name="props.name"
            :checked="props.modelValue.id === option.id"
            @click="onOptionClick(option)"
            class="tw-sr-only"
        >

        <label
            :for="getOptionId(option.id)"
            class="tw-w-full tw-h-full tw-cursor-pointer tw-text-gray-700 tw-text-lg md:tw-text-lg lg:tw-text-xl tw-font-medium tw-p-2 md:tw-p-3 lg:tw-p-2 xl:tw-p-3"
        >
            <div class="tw-w-full tw-leading-tight">
                <div class="tw-aspect-4/3 tw-relative tw-overflow-hidden tw-bg-gray-100 tw-mb-2 md:tw-mb-3 tw-rounded-sm">
                    <img v-if="option.image" :src="option.image" class="tw-absolute tw-left-0 tw-top-0 tw-size-full tw-object-cover" />
                </div>

                <p class="tw-text-lg md:tw-text-lg lg:tw-text-xl tw-font-medium" v-if="option.title" v-text="option.title"></p>
                <p class="tw-text-lg md:tw-text-lg lg:tw-text-xl tw-font-medium" v-if="option.teaser" v-text="option.teaser"></p>
                <p class="tw-text-md md:tw-text-md lg:tw-text-lg tw-font-normal" v-if="option.teaser2" v-text="option.teaser2"></p>
            </div>

            <div class="Divider tw-block tw-absolute tw-bottom-0 tw-left-2 tw-right-2 tw-w-auto tw-h-px tw-bg-gray-100 tw-z-10 tw-transition-colors tw-duration-300 group-hover:tw-bg-transparent"></div>
        </label>
        </div>
    </div>
</template>